var _style, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummaryIconBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 300 300",
    viewBox: "0 0 300 300",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.bank_st0{fill:#3D6EDF;}\n")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "bank_st0",
    d: "m289.99 128.58h-279.98c-5.37 0-9.72-4.35-9.72-9.72v-18.46c0-4.1 2.57-7.76 6.43-9.14l139.99-50.28c2.12-0.76 4.45-0.76 6.57 0l139.99 50.28c3.86 1.39 6.43 5.04 6.43 9.14v18.47c0 5.36-4.35 9.71-9.71 9.71zm-270.26-19.43h260.54v-1.92l-130.27-46.79-130.27 46.79v1.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bank_st0",
    d: "m289.99 227.74h-279.98c-5.37 0-9.72-4.35-9.72-9.72s4.35-9.72 9.72-9.72h279.97c5.37 0 9.72 4.35 9.72 9.72s-4.35 9.72-9.71 9.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bank_st0",
    d: "m25.07 200.71c-5.37 0-9.72-4.35-9.72-9.72v-45.22c0-5.37 4.35-9.72 9.72-9.72s9.72 4.35 9.72 9.72v45.22c0 5.37-4.35 9.72-9.72 9.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bank_st0",
    d: "m75.04 200.71c-5.37 0-9.72-4.35-9.72-9.72v-45.22c0-5.37 4.35-9.72 9.72-9.72s9.72 4.35 9.72 9.72v45.22c0 5.37-4.35 9.72-9.72 9.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bank_st0",
    d: "m125.01 200.71c-5.37 0-9.72-4.35-9.72-9.72v-45.22c0-5.37 4.35-9.72 9.72-9.72s9.72 4.35 9.72 9.72v45.22c0 5.37-4.35 9.72-9.72 9.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bank_st0",
    d: "m174.99 200.71c-5.37 0-9.72-4.35-9.72-9.72v-45.22c0-5.37 4.35-9.72 9.72-9.72s9.72 4.35 9.72 9.72v45.22c-0.01 5.37-4.36 9.72-9.72 9.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bank_st0",
    d: "m224.96 200.71c-5.37 0-9.72-4.35-9.72-9.72v-45.22c0-5.37 4.35-9.72 9.72-9.72s9.72 4.35 9.72 9.72v45.22c-0.01 5.37-4.36 9.72-9.72 9.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bank_st0",
    d: "m274.93 200.71c-5.37 0-9.72-4.35-9.72-9.72v-45.22c0-5.37 4.35-9.72 9.72-9.72s9.72 4.35 9.72 9.72v45.22c0 5.37-4.35 9.72-9.72 9.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bank_st0",
    d: "m289.99 259.6h-279.98c-5.37 0-9.72-4.35-9.72-9.72s4.35-9.72 9.72-9.72h279.97c5.37 0 9.72 4.35 9.72 9.72s-4.35 9.72-9.71 9.72z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryIconBank);
export default __webpack_public_path__ + "static/media/summary_icon_bank.b6753d13ab3a244ff60363b2aa6b8ed1.svg";
export { ForwardRef as ReactComponent };